
/* =========================================================
   MPM SHOP – PRODUCT LIGHTBOX CONTROLLER
   Desktop + Mobile
   Miniaturen, Pfeile, Tastatursteuerung
   ========================================================= */

if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {

      constructor() {
        super();

        this.mpmIndex = 0;

        
/* =========================================================
   MPM SHOP – SWIPE NAVIGATION
   Touch-Swipe auf dem grossen Produktbild
   ========================================================= */

this.mpmTouchStartX = 0;
this.mpmTouchStartY = 0;

const mpmImageArea = this.querySelector(
  '.product-media-modal__content'
);

if (mpmImageArea) {

  mpmImageArea.addEventListener(
    'touchstart',
    (event) => {
      if (event.touches.length !== 1) return;

      this.mpmTouchStartX = event.touches[0].clientX;
      this.mpmTouchStartY = event.touches[0].clientY;
    },
    { passive: true }
  );

  mpmImageArea.addEventListener(
    'touchend',
    (event) => {
      if (!this.hasAttribute('open')) return;
      if (!event.changedTouches.length) return;

      const deltaX =
        event.changedTouches[0].clientX -
        this.mpmTouchStartX;

      const deltaY =
        event.changedTouches[0].clientY -
        this.mpmTouchStartY;

      // Mindestens 45 Pixel horizontal bewegen.
      // Vertikales Scrollen nicht als Swipe werten.
      if (
        Math.abs(deltaX) < 45 ||
        Math.abs(deltaX) < Math.abs(deltaY) * 1.3
      ) {
        return;
      }

      // Nach links = naechstes Bild
      // Nach rechts = vorheriges Bild
      this.moveMPMMedia(deltaX < 0 ? 1 : -1);
    },
    { passive: true }
  );

}


        const dialog = this.querySelector(
          '.product-media-modal__dialog'
        );

        // Galerie-Steuerelemente direkt behandeln.
        // So erreichen deren Klicks nicht die
        // Schliessen-Funktion des uebergeordneten Modals.
        if (dialog) {

          dialog.addEventListener(
            'click',
            (event) => {
              const thumb = event.target.closest(
                '[data-mpm-media-target]'
              );

              const prev = event.target.closest(
                '[data-mpm-lightbox-prev]'
              );

              const next = event.target.closest(
                '[data-mpm-lightbox-next]'
              );

              if (!thumb && !prev && !next) return;

              event.preventDefault();
              event.stopPropagation();

              if (thumb) {
                this.activateMPMMedia(
                  thumb.dataset.mpmMediaTarget
                );
                return;
              }

              if (prev) {
                this.moveMPMMedia(-1);
                return;
              }

              if (next) {
                this.moveMPMMedia(1);
              }
            },
            true
          );

          // Verhindert unerwuenschtes Schliessen
          // durch Pointer-Ereignisse auf Desktop.
          ['pointerdown', 'pointerup'].forEach(
            (eventName) => {
              dialog.addEventListener(
                eventName,
                (event) => {
                  if (
                    event.target.closest(
                      '[data-mpm-media-target]'
                    ) ||
                    event.target.closest(
                      '[data-mpm-lightbox-prev]'
                    ) ||
                    event.target.closest(
                      '[data-mpm-lightbox-next]'
                    )
                  ) {
                    event.stopPropagation();
                  }
                },
                true
              );
            }
          );
        }

        // Tastatursteuerung
        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;

          if (
            event.target.closest(
              'input, textarea, select, [contenteditable="true"]'
            )
          ) {
            return;
          }

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.moveMPMMedia(-1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.moveMPMMedia(1);
          }
        });
      }

      // Alle Medien der Lightbox abrufen
      getMPMMedia() {
        return Array.from(
          this.querySelectorAll(
            '.product-media-modal__content > [data-media-id]'
          )
        );
      }

      // Lightbox oeffnen
      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      // Lightbox schliessen
      hide() {
        if (
          typeof window.pauseAllMedia === 'function'
        ) {
          window.pauseAllMedia();
        }

        super.hide();
      }

      // Angewaehltes Produktbild beim Oeffnen anzeigen
      showActiveMedia() {
        const mediaId =
          this.openedBy?.getAttribute('data-media-id');

        const media = this.getMPMMedia();

        if (!media.length) return;

        const selected = media.find(
          (item) =>
            item.dataset.mediaId === mediaId
        );

        this.activateMPMMedia(
          (selected || media[0]).dataset.mediaId
        );
      }

      // Einzelnes Bild aktivieren
      activateMPMMedia(mediaId) {
        const media = this.getMPMMedia();

        if (!media.length) return;

        const index = media.findIndex(
          (item) =>
            item.dataset.mediaId === String(mediaId)
        );

        if (index < 0) return;

        this.mpmIndex = index;

        // Laufende Videos pausieren
        if (
          typeof window.pauseAllMedia === 'function'
        ) {
          window.pauseAllMedia();
        }

        // Nur das aktive Medium anzeigen
        media.forEach((item, itemIndex) => {
          const active = itemIndex === index;

          item.classList.toggle('active', active);

          if (active) {
            item.removeAttribute('aria-hidden');
          } else {
            item.setAttribute('aria-hidden', 'true');
          }
        });

        const activeMedia = media[index];

        // Videos und 3D-Medien unterstuetzen
        const deferredMedia =
          activeMedia.matches('deferred-media')
            ? activeMedia
            : activeMedia.querySelector(
                'deferred-media'
              );

        if (
          deferredMedia &&
          typeof deferredMedia.loadContent === 'function'
        ) {
          deferredMedia.loadContent();
        }

        // Miniaturansichten aktualisieren
        this.updateMPMThumbnails(
          activeMedia.dataset.mediaId
        );
      }

      // Zum naechsten oder vorherigen Bild wechseln
      moveMPMMedia(direction) {
        const media = this.getMPMMedia();

        if (media.length < 2) return;

        const nextIndex =
          (
            this.mpmIndex +
            direction +
            media.length
          ) % media.length;

        this.activateMPMMedia(
          media[nextIndex].dataset.mediaId
        );
      }

      // Aktives Miniaturbild markieren
      updateMPMThumbnails(mediaId) {
        const thumbnails = Array.from(
          this.querySelectorAll(
            '[data-mpm-media-target]'
          )
        );

        thumbnails.forEach((thumb) => {
          const active =
            thumb.dataset.mpmMediaTarget ===
            String(mediaId);

          if (active) {
            thumb.setAttribute(
              'aria-current',
              'true'
            );
          } else {
            thumb.removeAttribute(
              'aria-current'
            );
          }
        });

        // Aktive Miniatur automatisch sichtbar halten
        const activeThumb = thumbnails.find(
          (thumb) =>
            thumb.dataset.mpmMediaTarget ===
            String(mediaId)
        );

        if (activeThumb) {
          const container = this.querySelector(
            '.mpm-lightbox__thumbnails'
          );

          if (container) {
            const targetLeft =
              activeThumb.offsetLeft -
              container.offsetLeft -
              (
                container.clientWidth -
                activeThumb.offsetWidth
              ) / 2;

            container.scrollTo({
              left: Math.max(0, targetLeft),
              behavior: 'smooth'
            });
          }
        }

        // Pfeile nur bei mehreren Medien anzeigen
        const arrows = this.querySelectorAll(
          '.mpm-lightbox__arrow'
        );

        const showArrows =
          this.getMPMMedia().length > 1;

        arrows.forEach((arrow) => {
          arrow.hidden = !showArrows;
        });
      }
    }
  );
}
